<form #environmentAdvancedForm="ngForm" class="bz-environment-advanced">
    <div class="bz-environment-advanced-left">
      <div class="bz-environment-advanced-left" *ngIf="sections.SchedulerInterval">
        <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.SCHEDULER_INTERVAL_OPTION" | translate}}</h5>

          <div class="bz-form-item--display-vertical bz-form-item bz-environment-advanced-left__input">
            <label class="bz-form-label">
              {{ "ENVIRONMENT.INTERVAL" | translate }}
            </label>
            <div class="bz-form-item__control">
              <div class="bz-control bz-time-picker">
                <div class="bz-time-picker__section bz-space--inline-xs">
                  <input class="bz-input bz-time-picker__section__input"
                         name="hoursInput"
                         type="number"
                         (keypress)="onlyNumbers($event)"
                         [(ngModel)]="schedulerInterval.hours"
                         (ngModelChange)="checkValue('hours', $event)">
                  <div class="bz-time-picker__arrows">
                    <svg class="bz-time-picker__arrows__item" (click)="goUp('hours')">
                      <use xlink:href="#arrow-up" />
                    </svg>
                    <svg class="bz-time-picker__arrows__item" (click)="goDown('hours')">
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </div>
                </div>
                <div class="bz-time-picker__separator bz-space--inline-xs">
                  :
                </div>
                <div class="bz-time-picker__section">
                  <input class="bz-input bz-time-picker__section__input"
                         name="minutesInput"
                         type="number"
                         (keypress)="onlyNumbers($event)"
                         [(ngModel)]="schedulerInterval.minutes"
                         (ngModelChange)="checkValue('minutes', $event)">
                  <div class="bz-time-picker__arrows">
                    <svg class="bz-time-picker__arrows__item" (click)="goUp('minutes')">
                      <use xlink:href="#arrow-up" />
                    </svg>
                    <svg class="bz-time-picker__arrows__item" (click)="goDown('minutes')">
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </div>
                </div>
                <div class="bz-time-picker__separator bz-space--inline-xs">
                  :
                </div>
                <div class="bz-time-picker__section bz-space--inline-s">
                  <input class="bz-input bz-time-picker__section__input"
                        name="secondsInput"
                        type="number"
                        (keypress)="onlyNumbers($event)"
                        [(ngModel)]="schedulerInterval.seconds"
                        (ngModelChange)="checkValue('seconds', $event)">
                  <div class="bz-time-picker__arrows">
                    <svg class="bz-time-picker__arrows__item" (click)="goUp('seconds')">
                      <use xlink:href="#arrow-up" />
                    </svg>
                    <svg class="bz-time-picker__arrows__item" (click)="goDown('seconds')">
                      <use xlink:href="#arrow-down" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="bz-environment-advanced-left__section">
            <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.WEB_SERVICES_INTERFACES_OPTIONS" | translate}}</h5>
            <bzg-input [ngModel]='parameters.webServicesTimeOut' (ngModelChange)="updateValue('webServicesTimeOut', $event)" type='number' class="bz-environment-advanced-left__input"
                placeholder="{{ 'ENVIRONMENT.WEB_SERVICES_TIME_OUT' | translate }}" name="webServicesTimeOut" (keypress)="utilsService.onlyNumbers($event)"
                [max]="metadata['webServicesInterfacesTimeout'].max === -1 ? undefined : metadata['webServicesInterfacesTimeout'].max"
                [min]="metadata['webServicesInterfacesTimeout']?.min"
                [required]="metadata['webServicesInterfacesTimeout']?.required">
                {{ 'ENVIRONMENT.WEB_SERVICES_TIME_OUT' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['webServicesInterfacesTimeout'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['webServicesInterfacesTimeout'].min}}</bzg-min-error>
            </bzg-input>
            <bzg-input [ngModel]='parameters.interfaceThresholdTime' (ngModelChange)="updateValue('interfaceThresholdTime', $event)" type='number' class="bz-environment-advanced-left__input"
                placeholder="{{ 'ENVIRONMENT.LOGGING_THRESHOLD' | translate}}" name="interfaceThresholdTime" (keypress)="utilsService.onlyNumbers($event)"
                [max]="metadata['webServicesInterfacesLoggingThreshold'].max === -1 ? undefined : metadata['webServicesInterfacesLoggingThreshold'].max"
                [min]="metadata['webServicesInterfacesLoggingThreshold']?.min"
                [required]="metadata['webServicesInterfacesLoggingThreshold']?.required">
                {{ 'ENVIRONMENT.LOGGING_THRESHOLD' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['webServicesInterfacesLoggingThreshold'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['webServicesInterfacesLoggingThreshold'].min}}</bzg-min-error>
            </bzg-input>
        </div>
        <div class="bz-environment-advanced-left__section">
            <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.ENTITIES_OPTION" | translate
                }}</h5>
            <bzg-input [ngModel]='parameters.attribMaxLengthThreshold' (ngModelChange)="updateValue('attribMaxLengthThreshold', $event)" type='number' class="bz-environment-advanced-left__input"
                placeholder="{{ 'ENVIRONMENT.ATRIBUTES_LENGTH_MAXIMUM_THRESHOLD' | translate }}" name="attribMaxLengthThreshold"
                [max]="metadata['attributeMaximumLength'].max === -1 ? undefined : metadata['attributeMaximumLength'].max"
                [min]="metadata['attributeMaximumLength']?.min"
                [required]="metadata['attributeMaximumLength']?.required"
                (keypress)="utilsService.onlyPositiveNumbers($event)">
                {{ 'ENVIRONMENT.ATRIBUTES_LENGTH_MAXIMUM_THRESHOLD' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['attributeMaximumLength'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['attributeMaximumLength'].min}}</bzg-min-error>
            </bzg-input>
            <bzg-input [ngModel]='parameters.paramEntityInstancesThreshold' (ngModelChange)="updateValue('paramEntityInstancesThreshold', $event)" type='number' class="bz-environment-advanced-left__input"
                placeholder="{{ 'ENVIRONMENT.PARAMETER_ENTITY_INSTANCE_CACHE_THRESHOLD' | translate }}" name="paramEntityInstancesThreshold"
                [max]="metadata['paramterEntityInstancesCacheLimit'].max === -1 ? undefined : metadata['paramterEntityInstancesCacheLimit'].max"
                [min]="metadata['paramterEntityInstancesCacheLimit']?.min"
                [required]="metadata['paramterEntityInstancesCacheLimit']?.required"
                (keypress)="utilsService.onlyPositiveNumbers($event)">
                {{ 'ENVIRONMENT.PARAMETER_ENTITY_INSTANCE_CACHE_THRESHOLD' | translate }}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['paramterEntityInstancesCacheLimit'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['paramterEntityInstancesCacheLimit'].min}}</bzg-min-error>
            </bzg-input>
        </div>

        <div class="bz-environment-advanced-left__section">
            <h5 class="bz-font-weight--semibold bz-space--stack-m">{{ "ENVIRONMENT.UPLOAD_OPTIONS" | translate}}</h5>
            <bzg-message class="bz-environment-advanced-left__message--info bz-space--stack-m" [showCloseBtn]="true" [status]="'info'">
              <span class="bz-space--inline-m"> {{'ENVIRONMENT.WINDOW_MAINTENANCE_REQUIRED_MESSAGE_UPLOAD_OPTIONS' | translate}} </span>
              <bzg-button-secondary class="bz-space--inline-m" (click)="navigateWindowMaintenance()">
              {{ "AUTHENTICATION.GO_MAINTENANCE_WINDOW" | translate }}
              </bzg-button-secondary>
          </bzg-message>
            <bzg-input [ngModel]='parameters.uploadMaxFileSize' (ngModelChange)="updateValue('uploadMaxFileSize', $event)" type='number' placeholder="{{ 'ENVIRONMENT.UPLOAD_MAX_FILE_SIZE' | translate }}"
                class="bz-environment-advanced-left__input" name="uploadMaxFileSize" (keypress)="utilsService.onlyPositiveNumbers($event)"
                [max]="metadata['uploadMaxFileSize'].max === -1 ? undefined : metadata['uploadMaxFileSize'].max"
                [min]="metadata['uploadMaxFileSize']?.min"
                [required]="metadata['uploadMaxFileSize']?.required">
                {{ "ENVIRONMENT.UPLOAD_MAX_FILE_SIZE" | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['uploadMaxFileSize'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['uploadMaxFileSize'].min}}</bzg-min-error>
            </bzg-input>
        </div>

        <div class="bz-environment-advanced-left__section" *ngIf="sections.CryptographyOptions">
            <h5 class="bz-font-weight--semibold bz-space--stack-m">{{ "ENVIRONMENT.CRYPTOGRAPHY_OPTIONS" | translate}}</h5>
                <div class="bz-space--stack-m">
                    <strong class="bz-environment-advanced__label bz-space--stack-xs">{{'ENVIRONMENT.CRYPTOGRAPHY_HASH_ALGORITHM' | translate}}</strong>
                    <bzg-select class="bz-environment-popular__input-section-double__select"
                        [(value)]="parameters.cryptographyHashAlgorithm">
                        <bzg-option *ngFor="let option of metadata['cryptographyHashAlgorithm'].options | keyvalue" [value]="option.key">
                            {{option.value}}
                        </bzg-option>
                    </bzg-select>
                </div>
                <div class="bz-space--stack-m">
                    <strong class="bz-environment-advanced__label bz-space--stack-xs">{{'ENVIRONMENT.CRYPTOGRAPHY_ENCRYPTION_ALGORITHM' | translate}}</strong>
                    <bzg-select class="bz-environment-popular__input-section-double__select"
                        [(value)]="parameters.cryptographyEncryptionAlgorithm">
                        <bzg-option *ngFor="let option of metadata['cryptographyEncryptionAlgorithm'].options | keyvalue" [value]="option.key">
                            {{option.value}}
                        </bzg-option>
                    </bzg-select>
                </div>
            <bzg-input [(ngModel)]='parameters.cryptographyKeyUrlFormat.UrlFileName' type='text' class="bz-environment-advanced-left__input bz-space--stack-m"
                placeholder="{{ 'ENVIRONMENT.CRYPTOGRAPHY_KEY_FILE_LOCATIONS' | translate }}" name="cryptographyKeyUrl.UrlFileName"
                [maxlength]="metadata['cryptographyKeyUrl']['items']['UrlFileName'].max === -1 ? undefined : metadata['cryptographyKeyUrl']['items']['UrlFileName'].max"
                [min]="metadata['cryptographyKeyUrl']['items']['UrlFileName']?.min"
                [required]="metadata['cryptographyKeyUrl']['items']['UrlFileName']?.required">
                {{ 'ENVIRONMENT.CRYPTOGRAPHY_KEY_FILE_LOCATIONS' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['UrlFileName'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['UrlFileName'].min}}</bzg-min-error>
            </bzg-input>
            <div>
              <div class="bz-environment-advanced-right__switch-container">
                  <span>{{ "ENVIRONMENT.CRYPTOGRAPHY_CONFIGURE_AUTHENTICATION" | translate }}</span>
                  <bzg-switch [(ngModel)]='parameters.cryptographyKeyUrlFormat.ConfigureAuthentication' name="cryptographyKeyUrl.ConfigureAuthentication"></bzg-switch>
              </div>
            </div>
            <div *ngIf="parameters.cryptographyKeyUrlFormat.ConfigureAuthentication">
              <bzg-input [(ngModel)]='parameters.cryptographyKeyUrlFormat.Domain' type='text' class="bz-environment-advanced-left__input"
                  placeholder="{{ 'ENVIRONMENT.CRYPTOGRAPHY_DOMAIN' | translate }}" name="cryptographyKeyUrl.Domain"
                  [maxlength]="metadata['cryptographyKeyUrl']['items']['Domain'].max === -1 ? undefined : metadata['cryptographyKeyUrl']['items']['Domain'].max"
                  [min]="metadata['cryptographyKeyUrl']['items']['Domain']?.min"
                  [required]="metadata['cryptographyKeyUrl']['items']['Domain']?.required">
                  {{ 'ENVIRONMENT.CRYPTOGRAPHY_DOMAIN' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['Domain'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['Domain'].min}}</bzg-min-error>
              </bzg-input>
              <bzg-input [(ngModel)]='parameters.cryptographyKeyUrlFormat.UserName' type='text' class="bz-environment-advanced-left__input"
                  placeholder="{{ 'ENVIRONMENT.CRYPTOGRAPHY_USERNAME' | translate }}" name="cryptographyKeyUrl.UserName"
                  [maxlength]="metadata['cryptographyKeyUrl']['items']['UserName'].max === -1 ? undefined : metadata['cryptographyKeyUrl']['items']['UserName'].max"
                  [min]="metadata['cryptographyKeyUrl']['items']['UserName']?.min"
                  [required]="metadata['cryptographyKeyUrl']['items']['UserName']?.required">
                  {{ 'ENVIRONMENT.CRYPTOGRAPHY_USERNAME' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['UserName'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['UserName'].min}}</bzg-min-error>
              </bzg-input>
              <bzg-input [(ngModel)]='parameters.cryptographyKeyUrlFormat.Password' type='password' class="bz-environment-advanced-left__input"
                  placeholder="{{ 'ENVIRONMENT.CRYPTOGRAPHY_PASSWORD' | translate }}" name="cryptographyKeyUrl.Password"
                  [maxlength]="metadata['cryptographyKeyUrl']['items']['Password'].max === -1 ? undefined : metadata['cryptographyKeyUrl']['items']['Password'].max"
                  [min]="metadata['cryptographyKeyUrl']['items']['Password']?.min"
                  [required]="metadata['cryptographyKeyUrl']['items']['Password']?.required"
                  (blur)="cryptographyKeyUrlPassword()">
                  {{ 'ENVIRONMENT.CRYPTOGRAPHY_PASSWORD' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['Password'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['cryptographyKeyUrl']['items']['Password'].min}}</bzg-min-error>
              </bzg-input>
            </div>
        </div>

        <div class="bz-environment-advanced-left__section bz-space--stack-m">
            <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.SECURITY" | translate}}</h5>
            <bzg-input [(ngModel)]='parameters.corsAllowOrigins'
                class="bz-environment-advanced-left__input" name="corsAllowOrigins"
                [max]="metadata['corsAllowOrigins'].max === -1 ? undefined : metadata['corsAllowOrigins'].max"
                [min]="metadata['corsAllowOrigins']?.min"
                [required]="metadata['corsAllowOrigins']?.required" validateDomain>
                {{ "ENVIRONMENT.TRUSTED_DOMAINS_CORS" | translate}}
                <bzg-input-error-custom *ngIf="environmentAdvancedForm.controls.corsAllowOrigins && environmentAdvancedForm.controls.corsAllowOrigins.errors && environmentAdvancedForm.controls.corsAllowOrigins.errors.validateDomain">
                    {{environmentAdvancedForm.controls.corsAllowOrigins.errors.validateDomain | translate}}
                </bzg-input-error-custom>
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['corsAllowOrigins'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['corsAllowOrigins'].min}}</bzg-min-error>
            </bzg-input>
        </div>
    </div>

    <div class="bz-environment-advanced-right">
        <div class="bz-environment-advanced-right__container">
            <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.SOA_OPTIONS" | translate }}</h5>
            <div class="bz-environment-advanced-right__switch-container">
                <span>{{ "ENVIRONMENT.SOA_KEY_ENFORCEMENT" | translate }}</span>
                <bzg-switch [(ngModel)]='parameters.soaBusinessKeyEnforcement' name="soaBusinessKeyEnforcement"></bzg-switch>
            </div>

            <div class="bz-environment-advanced-right__container">
                <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.ABORT_NOTIFICATIONS" | translate }}</h5>
                <div class="bz-environment-advanced-right__switch-container">
                    <span class="bz-environment-advanced-right__switch-container__text">{{
                        "ENVIRONMENT.DISABLE_ABORT_NOTIFICATIONS" | translate }}</span>
                    <bzg-switch [(ngModel)]='parameters.disableAbortNotifications' name="disableAbortNotifications"></bzg-switch>
                </div>
                <div class="bz-environment-advanced-right__switch-container">
                    <span class="bz-environment-advanced-right__switch-container__text">{{
                        "ENVIRONMENT.INCLUDE_EVENTS_ON_NOTIFICATIONS" | translate }}</span>
                    <bzg-switch [(ngModel)]='parameters.includeEventsOnNotifications' name="includeEventsOnNotifications"></bzg-switch>
                </div>
            </div>

            <div class="bz-environment-advanced-right__container">
                <h5 class="bz-font-weight--semibold">{{ "ENVIRONMENT.LOG_OPTIONS" | translate }}</h5>
                <div class="bz-environment-advanced-right__switch-container">
                    <span class="bz-environment-advanced-right__switch-container__text">{{
                        "ENVIRONMENT.ENABLE_JOB_LOGGING" | translate }}</span>
                    <bzg-switch [(ngModel)]='parameters.logging' name="logging"></bzg-switch>
                </div>
                <div class="bz-environment-advanced-right__switch-container">
                    <span class="bz-environment-advanced-right__switch-container__text">{{
                        "ENVIRONMENT.ENABLE_MM_RELATIONSHIP_LOG" | translate }}</span>
                    <bzg-switch [(ngModel)]='parameters.enableMMFactLog' name="enableMMFactLog"></bzg-switch>
                </div>
                <div class="bz-environment-advanced-right__switch-container">
                    <span>{{ "ENVIRONMENT.ENABLE_ENTITY_LOG" | translate }}</span>
                    <bzg-switch [(ngModel)]='parameters.enableEntityLog' name="enableEntityLog"></bzg-switch>
                </div>
            </div>
        </div>
    </div>
</form>
